/* Base translations · Lead sheet — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): lead. */
export const I18N_BASE_LEAD = {
  en: {
    lead: {
      title: "Lead sheet",
      leadTotal: "Lead sheet total",
      fsTotal: "IFRS Statements",
      agreesToFs: "Agrees to financial statements",
      diffFs: "Difference to financial statements",
      noFsTotal: "No FS head total available (mapping empty).",
      totals: "Totals",
      tickmarkLegend: "Tick-marks — ✓ agreed to TB · ⊕ agreed to PY audited · Σ cast · ✱ see note",
      col: { account: "Account", name: "Name", pyFinal: "PY final",
              cyUnadj: "CY unadjusted", adj: "Adjustments",
              cyUnadjLayer: "Client books", adjLayer: "Posted adjusting entries", cyFinalLayer: "After audit adjustments",
              adjEntries: "Entries behind this amount", manualBefore: "Typed before adjusting entries (not counted): ",
              noAdjEntries: "No adjusting entry on this account",
              cyFinal: "CY final", mvmt: "Movement", mvmtPct: "Movement %",
              tick: "Tick-mark", wp: "WP ref" },
      pySource: {
        prior_year_tb: "Prior-year TB",
        prior_year_gl: "Prior-year GL (closing balance)",
        prior_gl_closing: "Derived from prior-year GL",
        not_available: "PY not available (prior-year GL has no opening-balance journal)",
        none: "No prior-year data",
      },
      explanation: "Explanation of movement",
      arMovementExpl: "Movement explanation",
      explanationRequired: "Explanation is required — |movement| ≥ performance materiality.",
      noPriorYearReason: "No prior-year TB — reason for the manually entered PY",
      conclusion: "Conclusion",
      preparer: "Preparer",
      reviewer: "Reviewer",
      markComplete: "Mark complete",
      sap: {
        title: "Substantive analytics — ISA 520 expectation",
        expectationAmount: "Expectation (amount)",
        expectationBasis: "Expectation (basis)",
        acceptableDifference: "Acceptable difference",
        difference: "Difference (CY final − expectation)",
        overThreshold: "Difference exceeds acceptable difference — explain below",
        explanation: "SAP explanation",
      },
    },
  },
  ar: {
    lead: {
      title: "الورقة الرئيسية",
      leadTotal: "إجمالي الورقة الرئيسية",
      fsTotal: "القوائم المالية",
      agreesToFs: "المطابقة مع القوائم المالية",
      diffFs: "الفرق مع القوائم المالية",
      noFsTotal: "لا يتوفر إجمالي للبند (تعيين فارغ).",
      totals: "الإجماليات",
      tickmarkLegend: "علامات المراجعة — ✓ طُوبقت مع ميزان المراجعة · ⊕ طُوبقت مع سنة سابقة مدققة · Σ جمع · ✱ انظر الملاحظة",
      col: { account: "الحساب", name: "الاسم", pyFinal: "النهائي للسنة السابقة",
              cyUnadj: "غير المعدّل للسنة الحالية", adj: "التسويات",
              cyUnadjLayer: "دفاتر العميل", adjLayer: "قيود التسوية المرحّلة", cyFinalLayer: "بعد تسويات المراجعة",
              adjEntries: "القيود وراء هذا المبلغ", manualBefore: "أُدخل يدويًا قبل قيود التسوية (غير محتسب): ",
              noAdjEntries: "لا يوجد قيد تسوية على هذا الحساب",
              cyFinal: "النهائي للسنة الحالية", mvmt: "التغيّر",
              mvmtPct: "نسبة التغيّر", tick: "علامة المراجعة", wp: "مرجع ورقة العمل" },
      pySource: {
        prior_year_tb: "ميزان مراجعة السنة السابقة",
        prior_year_gl: "دفتر الأستاذ للسنة السابقة (الرصيد الختامي)",
        prior_gl_closing: "مشتق من دفتر أستاذ السنة السابقة",
        not_available: "السنة السابقة غير متاحة (دفتر الأستاذ للسنة السابقة بلا قيد أرصدة افتتاحية)",
        none: "لا توجد بيانات للسنة السابقة",
      },
      explanation: "تفسير التغيّر",
      arMovementExpl: "تفسير التغيّر",
      explanationRequired: "التفسير مطلوب — |التغيّر| ≥ الأهمية النسبية للأداء.",
      noPriorYearReason: "لا يوجد ميزان مراجعة سابق — سبب الإدخال اليدوي",
      conclusion: "الاستنتاج",
      preparer: "المُعِد",
      reviewer: "المراجع",
      markComplete: "وضع علامة \"مكتمل\"",
      sap: {
        title: "إجراءات تحليلية جوهرية — توقع ISA 520",
        expectationAmount: "قيمة التوقع",
        expectationBasis: "أساس التوقع",
        acceptableDifference: "الفرق المقبول",
        difference: "الفرق (النهائي − التوقع)",
        overThreshold: "الفرق يتجاوز الحد المقبول — يرجى التفسير أدناه",
        explanation: "تفسير الإجراءات التحليلية",
      },
    },
  },
};

export default I18N_BASE_LEAD;
